
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { TooltipInitService } from '../compartidos/services/tooltip-init.service';
import { ClientSwitchService } from '../compartidos/services/client-switch.service';

@Component({
  selector: 'app-layout',
  imports: [HeaderComponent, RouterOutlet],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {

  private _ = inject(TooltipInitService); // ✅ esto activa el servicio al renderizar el layout

  // Vigila el cambio de cliente desde cualquier pantalla, no solo el dashboard
  private _clientSwitch = inject(ClientSwitchService);
}
